// extracted by mini-css-extract-plugin
export default {"wrap":"growth-on-sales_wrap__Ogulr","chart":"growth-on-sales_chart__ruH8X"};